import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { baseUrl } from "config/config";
import { getApiCall } from "services/apiHelper";


interface UserState {
    data: UserResponse;
    loading: boolean;
    error: string | null;
}

interface UserResponse {
    message: string;
    result: User[];
}

interface User {
    itemId: number;
    role: string;
    status: string;
    emailId: string;
    firstName: string;
    lastName: string;
    created: string;
    createdBy: string;
    modified: string;
    modifiedBy: string;
}

const initialState: UserState = {
    data: {
        message: "",
        result: []
    },
    loading: false,
    error: null
};

export const getUserData = createAsyncThunk("getUserData", async (_, { rejectWithValue }) => {
    try {
        var url = `${baseUrl}UserRoleMap/GetByEmailId`;
        const response = await getApiCall<any>(url);
        return response.result;
    } catch (error: any) {
        console.error('Error in GET request:', error);
        return rejectWithValue(`${error.response.data.description} (${error.response.data.code})` || error.message);
    }
})

const userContextDetailSlice = createSlice({
    name: 'userContextDetail',
    initialState,
    reducers: {
        resetState: (state) => {
            return initialState

        }
    },
    extraReducers: (builder) => {
        builder.addCase(getUserData.pending, (state) => {
            state.loading = true;
        })
            .addCase(getUserData.fulfilled, (state, action: PayloadAction<UserResponse>) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(getUserData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'something went wrong';
            })
    },
});

export const getuserdetailsdata = (state: any) => state.userContextDetail.data

export default userContextDetailSlice.reducer;
